import '../sass/main.scss';
//import 'bootstrap';
import "./AgeGate/AgeGate";
import "./ContactModal/ContactModal";
import './tracking-events.js';

import 'flatpickr/dist/themes/material_blue.css'
import flatpickr from "flatpickr";
import { Romanian } from "flatpickr/dist/l10n/ro.js";

window.addEventListener( 'load', () => {

    let maxDate = new Date();
    maxDate.setFullYear( maxDate.getFullYear() - 18 );

    Array.from( document.querySelectorAll( '.js-datepicker' ) ).forEach( dateInput => {
        flatpickr( dateInput, {
            locale: Romanian,
            dateFormat: 'Y-m-d',
            altInput: true,
            altFormat: 'd-m-Y',
            allowInput: true,
            disableMobile: true,
            maxDate: maxDate
        } );
    } );
} );

jQuery( document ).ready( function ($) {
    "use strict";
    $( '#playvideo' )
        .modal( {
            show: false,
        } )
        .on( 'hidden.bs.modal', function () {
            $( this ).find( 'video' )[0].pause();
        } );
} );

jQuery(document).ready(function ($) {
    $(document).click(
        function (event) {
            var target = $(event.target);
            var _mobileMenuOpen = $(".navbar-collapse").hasClass("show");
            if (_mobileMenuOpen === true && !target.hasClass("navbar-toggler")) {
                $("button.navbar-toggler").click();
            }
        }
    );
});


//#! Inject Consent CookieBot scripts if the AgeGate has been passed
// jQuery( function ($) {
//     var _lsData = localStorage.getItem( 'bth_ls_data' ),
//         lsData = ( _lsData ? JSON.parse( _lsData ) : { age_verified: false } );
//
//     if ( lsData.age_verified ) {
//         $( 'head' )
//             .append( '<script id="Cookiebot" src="https://consent.cookiebot.com/uc.js" data-culture="RO" data-cbid="61dc789f-f748-4123-ae26-c3a19d02d7c5" data-blockingmode="auto" type="text/javascript"></script>' )
//             .append( '<script id="CookieDeclaration" src="https://consent.cookiebot.com/61dc789f-f748-4123-ae26-c3a19d02d7c5/cd.js" type="text/javascript" async></script>' );
//     }
// } );
